import { gql } from '@apollo/client'
import { AddressFragment } from './address.fragments'
import { FirmFragments } from './firm.fragments'

export const FirmProfileInfoFragments = {
    firmProfileInfoFragment: gql`
        ${FirmFragments.firmProfileInfoFragment}
        ${AddressFragment}
    `,
    firmProfileInfoPageFragment: gql`
        fragment firmProfileInfoPageFragment on FirmProfileInfo {
            address {
                ...addressFragment
            }
            publicPhone
            bannerUrl
            logoUrl
            website
            whoWeAre
        }
        ${AddressFragment}
    `,
}